<div
  class="modal-container"
  [ngClass]="extraClass ?? ''"
  *ngIf="show"
  (keydown)="onKeydown($event.key.toLowerCase())"
>
  <div class="modal-positioner" [class.cyc-modal]="cycModal">
    <div
      class="modal"
      [class.uni-list-modal]="uniListModal"
      [class.cyc-modal]="cycModal"
    >
      <img
        class="close-modal"
        src="/assets/icons/close-btn.svg"
        (click)="closeModal()"
      />
      <div class="modal-content">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
